import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class EllipseFactory extends AbstractShapeFactory {

  constructor() {
    super();
    this.awType = 'circle';
    this.parentButton = WBUtils.buttonBasic;
  }

  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    this.shapeObject = new fabric.Ellipse({
      rx: 5,
      ry: 5,
      left: anchorX,
      top: anchorY,
      stroke: color,
      strokeWidth: stroke,
      fill: fill,
      selectable: false
    });

    return this.shapeObject;
  }

  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    if (anchorX > eventX) {
      this.shapeObject.set({
        left: Math.abs(eventX)
      });
    }

    if (anchorY > eventY) {
      this.shapeObject.set({
        top: Math.abs(eventY)
      });
    }

    const rx = Number(Math.abs(anchorX - eventX) / 2);
    const ry = Number(Math.abs(anchorY - eventY) / 2);

    this.shapeObject.set({ rx: rx });
    this.shapeObject.set({ ry: ry });
    this.shapeObject.setCoords();
  }

  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }

}
